import _range from 'lodash/range';

export default _range(new Date().getFullYear() - 20, new Date().getFullYear() + 21).map(year => ({
  value: year.toString(),
  label: year.toString(),
}));
